import { Box, Card, CardActionArea, CardContent, Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useSideMenuUser } from 'src/shared/components/navigations/side-menu/useSideMenuUser';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { AdminRoutesEnum, RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';

export const SettingsPage = () => {
  const { t } = useTranslation();
  const { currentUser } = useGlobals();
  const navigate = useNavigate();

  const menuUserItems = useSideMenuUser();

  const getSettingsItems = menuUserItems.find((item) => item.yvName === SysProductYvNameEnum.Settings && item.showMenuItem === true);
  const subMenuItems = getSettingsItems?.subMenuItems?.filter((x) => x.showMenuItem) ?? [];

  const linkToPage = (route: RoutesEnum | AdminRoutesEnum) => {
    navigate(route);
  };

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader title={t('common:sideMenu.settings')} />
      </Grid>
      <Grid container spacing={5} p={2}>
        {subMenuItems.map((item) => {
          const isSubMenuItemDisabled = !getPermission(currentUser, item.permission ?? '');

          if (isSubMenuItemDisabled) return null;

          return (
            <Grid item xs={12} sm={6} md={4} key={item.key}>
              <Card>
                <CardActionArea onClick={() => linkToPage(item.link)}>
                  <CardContent
                    sx={{
                      minHeight: 160,
                      display: 'grid',
                      placeItems: 'center',
                      textAlign: 'center',
                      gap: 1.25,
                    }}
                  >
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: '50%',

                        display: 'grid',
                        placeItems: 'center',
                        '& .MuiSvgIcon-root': { fontSize: 30 },
                        color: 'text.secondary',
                      }}
                      aria-hidden
                    >
                      {item.Icon}
                    </Box>

                    <Typography variant='h6' fontWeight={500}>
                      {t(item.label)}
                    </Typography>
                    <Grid item xs={12} height='1px' width='100%'>
                      <Divider />
                    </Grid>
                    <Typography
                      variant='body2'
                      color='text.secondary'
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '3em',
                      }}
                    >
                      {item.description ? t(`common:${item.description}`) : null}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </GridWrapper>
  );
};
